<div class="generate-adhoc-report-container">
  <ptg-breadcrumb
    [listBreadcrumbs]="listBreadcrumbs"
  ></ptg-breadcrumb>

  <div class="generate-adhoc-report-section flex flex-col p-6">
    <div class="pb-6" *ngIf="bannerType">
        <ptg-banner
          [(bannerType)]="bannerType"
          [message]="message"
        ></ptg-banner>
    </div>
    <div class="flex flex-col gap-4">
      <div class="flex date-field-section gap-x-4">
        <ptg-button
          classInput="primary"
          buttonName="Design New Report"
          type="submit"
          class="generate-button"
          [routerLink]="['/member/adhoc-report/designer']"
        >
        </ptg-button>
        <ptg-button
          classInput="primary"
          buttonName="Use Template"
          type="submit"
          class="generate-button"
          (click)="openColumnSetDialog()"
        >
        </ptg-button>
      </div>
    </div>
    <div class="flex-grow overflow-hidden generate-letters-section mt-12">
      <div class="header">
        <span class="title font-bold">Generated Reports</span>
      </div>
      <ptg-grid
        [data]="tableData"
        [isLoading]="isTableLoading"
        [columns]="columns"
        [pageSize]="pageSize"
        [pageNumber]="pageIndex"
        [totalRecords]="totalRecords"
        (pageChange)="onChangePage($event)"
        (sortChange)="onSortChange($event)"
        [fitToParent]="true"
        notFoundMessage="No Data to Display"
      >
        <ng-template cellContent columnName="fileName" let-row>
          <div class="flex file-document-container">
            <span *ngIf="row.downloadable" stopPropagation (click)="downloadLetter(row)" class="file-document-name" target="_blank">
              <span class="truncate">{{ row?.fileName || '' }}</span>
            </span>
          </div>
        </ng-template>
        <ng-template cellContent columnName="action" let-row>
          <ptg-button *ngIf="row.removable"
            buttonName="Remove"
            classInput="remove-button"
            (clickButton)="removeReport(row)"
          >
            <mat-icon>delete_forever</mat-icon>
          </ptg-button>
        </ng-template>
      </ptg-grid>
    </div>
  </div>
</div>
